export const AUTHENTICATED_PROFESSIONAL = 'AUTHENTICATED_PROFESSIONAL'

export interface AuthenticatedProfessionalActionType {
    type: typeof AUTHENTICATED_PROFESSIONAL;
    id: string;
  }

export const authenticateProfessionalAction = (professionalId: string):
  AuthenticatedProfessionalActionType => ({ type: AUTHENTICATED_PROFESSIONAL, id: professionalId })
